import React, { useState, useEffect } from 'react';
import './App.css';
import { Amplify } from 'aws-amplify';
import { withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import awsconfig from './aws-exports';
import { getProfile, getInfo } from './api';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Chat from './pages/Chat';
import ProfilePage from './pages/ProfilePage';
import SubscribePage from './pages/SubscribePage';

Amplify.configure(awsconfig);
cognitoUserPoolsTokenProvider.setKeyValueStorage(window.localStorage);

function App({ signOut, user }) {
  const [theme, setTheme] = useState('light');
  const [info, setInfo] = useState('');
  const [profileData, setProfileData] = useState(null);

  useEffect(() => {
    // Fetch info and user profile when component mounts
    fetchInfo();
    fetchUserProfile();
    
    // Set initial theme from localStorage or default to light
    const savedTheme = localStorage.getItem('theme') || 'light';
    setTheme(savedTheme);
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  const fetchInfo = async () => {
    const info = await getInfo();
    setInfo(info);
  };
  
  const fetchUserProfile = async () => {
    try {
      const profile = await getProfile();
      setProfileData(profile);
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };
  
  const handleThemeChange = (newTheme) => {
    setTheme(newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
    localStorage.setItem('theme', newTheme);
  };

  return (
    <Router>
      <div className="min-h-screen bg-base-100">
        <Navbar 
          theme={theme} 
          handleThemeChange={handleThemeChange} 
          profileData={profileData} 
          signOut={signOut} 
          info={info} 
          user={user}
        />
        
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/subscribe" element={<SubscribePage />} />
          <Route 
            path="/chat" 
            element={
              user ? <Chat /> : <Navigate to="/" replace />
            } 
          />
          <Route 
            path="/profile" 
            element={
              user ? <ProfilePage /> : <Navigate to="/" replace />
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default withAuthenticator(App);
